<div *ngIf="grants">
  <micro-picklist title="Grants" idField="grant" displayField="grant" [all]="grants" [(selectedIds)]="selectedGrants" (selectedIdsChange)="onNgModelChange($event)"></micro-picklist>
</div>
